import HttpClientToken from '../../services/HttpClientToken';

import { TipoResolucionProps, defaultTipoResolucion } from '../../interfaces/catalogos/TipoResolucionInterface';

export const TipoResoluciones = () => {

    return new Promise<TipoResolucionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoResolucion/', token)
            .then( ({ data } : { data : TipoResolucionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoResolucion = () => {

    return new Promise<TipoResolucionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoResolucion/ObtenerTipoResoluciones', token)
            .then( ({ data } : { data : TipoResolucionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoResolucion = ( params: TipoResolucionProps ) => {

    return new Promise<TipoResolucionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoResolucion/Actualizar', params, token)
            .then( ({ data } : { data : TipoResolucionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoResolucion } );
            });

        }

    });

}

export const AgregarTipoResolucion = ( params: TipoResolucionProps ) => {

    return new Promise<TipoResolucionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoResolucion/Agregar', params, token)
            .then( ({ data } : { data : TipoResolucionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoResolucion } );
            });

        }

    });

}
